export default "__VITE_ASSET__Dq1BEB3R__"